import request from '@/router/axios'
import env from '../../config/env'

/**
 * 获取列表
 */
export const bottomNavList = () => {
  return request({
    url: `${env.ferryUrl}/advertising/navigation/list`,
    method: 'get'
  })
}

/**
 * 编辑
 */
export const editBottomNav = (data) => {
  return request({
    url: `${env.ferryUrl}/advertising/navigation/update`,
    method: 'post',
    data
  })
}

/**
 * 查看详情
 */
export const bottomNavDetail = (data) => {
  return request({
    url: `${env.ferryUrl}/advertising/navigation/detail`,
    method: 'post',
    data
  })
}
